import { PIN_PATHS, PIN_VIEWBOX } from './placePin.js';

// Kartvy's Adress tool (the pill menu's pin button): while it's on, the cursor is the site's pin, and a click on
// the map asks Nominatim for the street address there. One with a house number close to the click drops the
// "Gå till" pin on it with its place card open (the address's sales and its area's prices); anywhere else the
// map says to click an address instead.

// How far (m) the address Nominatim answers with may be from the click: a big block's address point can sit
// 30–50 m from where it was clicked; further than this and it's another building.
const MAX_METRES = 50;
// The keys an OSM address keeps its street name under, most usual first.
const ROAD_KEYS = ['road', 'pedestrian', 'footway', 'residential', 'square', 'place', 'path'];

// The cursor: the pin at 32×30, its tip (the hotspot) at the point. A CSS value for --place-pick-cursor.
const CURSOR_W = 32;
const CURSOR_H = 30;
const CURSOR_TIP = [16, 26];
export const PLACE_PICK_CURSOR = (() => {
    const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${CURSOR_W}" height="${CURSOR_H}" viewBox="${PIN_VIEWBOX}">${PIN_PATHS}</svg>`;
    return `url("data:image/svg+xml,${encodeURIComponent(svg)}") ${CURSOR_TIP[0]} ${CURSOR_TIP[1]}, crosshair`;
})();

const metresBetween = (lat1, lng1, lat2, lng2) => {
    const rad = Math.PI / 180;
    const dLat = (lat2 - lat1) * rad;
    const dLng = (lng2 - lng1) * rad;
    const a = Math.sin(dLat / 2) ** 2 + Math.cos(lat1 * rad) * Math.cos(lat2 * rad) * Math.sin(dLng / 2) ** 2;
    return 6371000 * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
};

// The street address at a point: { lat, lng, title: "Sveavägen 120", town }, or null when there's none with a
// number close by. Throws when Nominatim can't be asked.
export const findAddressAt = async (lat, lng) => {
    const url = `https://nominatim.openstreetmap.org/reverse?format=jsonv2&zoom=18&addressdetails=1&accept-language=sv&lat=${lat}&lon=${lng}`;
    const response = await fetch(url);
    if (!response.ok) throw new Error(`reverse ${response.status}`);
    const body = await response.json();
    const address = body?.address || {};
    const road = ROAD_KEYS.map((key) => address[key]).find(Boolean);
    // "12;14" or "1-3": the first.
    const number = String(address.house_number || '').split(/[;,]/)[0].trim();
    if (!road || !/^\d{1,4}\s*[A-Za-z]?(-\d+)?$/.test(number)) return null;
    const foundLat = Number(body.lat);
    const foundLng = Number(body.lon);
    if (!Number.isFinite(foundLat) || !Number.isFinite(foundLng)) return null;
    if (metresBetween(lat, lng, foundLat, foundLng) > MAX_METRES) return null;
    return {
        lat: foundLat,
        lng: foundLng,
        title: `${road} ${number.split('-')[0]}`,
        town: address.city || address.town || address.village || address.suburb || address.municipality || '',
    };
};

// The note when a click finds no address, and when the tool is turned on.
export const placePickHint = (swedish, touch) => (swedish
    ? `${touch ? 'Tryck' : 'Klicka'} på en adress för att se dess prishistorik`
    : `${touch ? 'Tap' : 'Click'} an address to see its price history`);
